import React from 'react';
import AdminPlaceholderScreen from './AdminPlaceholderScreen';

const AdminUtilities = ({route}) => (
  <AdminPlaceholderScreen
    title="Admin utilities"
    replacedBy="GROOV-5188 (admin utilities)"
    onOpenMenu={() => route?.params?.openMenuDrawer?.()}
  />
);

export default AdminUtilities;
